const items = [
  "Gone Today Junk Removal",
  "Free Quotes",
  "Massachusetts",
  "Rhode Island",
  "You Point — We Haul",
  "Same-Day Pickups",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <section aria-hidden="true" className="overflow-hidden border-y border-navy/15 bg-ice py-6" data-testid="marquee-section">
      <div className="animate-marquee flex w-max items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-4xl uppercase tracking-wide text-outline-navy sm:text-6xl whitespace-nowrap">
              {item}
            </span>
            <span className="h-3 w-3 bg-royal" />
          </span>
        ))}
      </div>
    </section>
  );
}
